import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import 'aos/dist/aos.css';
import AOS from 'aos';
import whobanner from "../img/bpo.png";
import {
  FaBuilding, FaMobileAlt, FaGlobe, FaCloud, FaChartLine, FaLink,
  FaLightbulb, FaPaintBrush, FaCode, FaCogs, FaHeadset, FaReact,
  FaNodeJs, FaAws, FaShieldAlt, FaTools, FaClock, FaExpand
} from 'react-icons/fa';

/**
 * BusinessProcessOutsourcing.jsx
 *
 * Same UI structure as the Custom Software page,
 * updated content for Business Process Outsourcing (BPO).
 */

const BusinessProcessOutsourcing = ({ name }) => {
  const videoRef = useRef(null);
  const carouselRef = useRef(null);
  const [openFAQ, setOpenFAQ] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phoneno: '',
    country_code: '+91',
    location: '',
    industry_type: '',
    availability: '',
    type_of_service: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formMessage, setFormMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({ title: '', message: '', status: 'info' });
  const [faqFiles, setFaqFiles] = useState({});
  const navigate = useNavigate();

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
 const nameRegex = /^[A-Za-z\s]+$/;
const phoneDigitsRegex = /^[0-9]{10}$/;


  const countryCodes = [
    { code: '+91', flag: '🇮🇳', label: 'India' },
    { code: '+1', flag: '🇺🇸', label: 'United States' },
    { code: '+44', flag: '🇬🇧', label: 'United Kingdom' },
    { code: '+61', flag: '🇦🇺', label: 'Australia' },
    { code: '+971', flag: '🇦🇪', label: 'UAE' },
  ];

  const API_BASE = process.env.REACT_APP_API_URL || 'https://api.securxperts.com:8000';

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({ duration: 900, once: true, easing: 'ease-in-out' });

    const handleScroll = () => {
      if (videoRef.current) {
        const translateY = window.scrollY * 0.25;
        videoRef.current.style.transform = `translateY(${translateY}px)`;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [name]);

  const toggleFAQ = (index) => setOpenFAQ(openFAQ === index ? null : index);
  const scrollLeft = () => carouselRef.current?.scrollBy({ left: -300, behavior: 'smooth' });
  const scrollRight = () => carouselRef.current?.scrollBy({ left: 300, behavior: 'smooth' });

const handleInputChange = (e) => {
  const { id, value } = e.target;

  
  if (id === "name") {
    if (!/^[A-Za-z\s]*$/.test(value)) return;
  }

  // Phone: allow only numbers & max 10 digits
  if (id === "phoneno") {
    if (!/^[0-9]*$/.test(value)) return;
    if (value.length > 10) return;
  }

  setFormData(prev => ({ ...prev, [id]: value }));
};


  const handleCountryCodeChange = (e) => {
    const value = e.target.value;
    setFormData(prev => ({ ...prev, country_code: value }));
  };

  const handleFaqFileChange = (e, index) => {
    const file = e.target.files && e.target.files[0];
    setFaqFiles(prev => ({ ...prev, [index]: file }));
  };

const validateForm = () => {
  const { name, email, phoneno, country_code, location, industry_type, availability, type_of_service } = formData;

  if (!name || !email || !phoneno || !country_code || !location || !industry_type || !availability || !type_of_service) {
    return 'Please fill out all fields.';
  }

  if (!nameRegex.test(name)) {
    return 'Name should contain only alphabets.';
  }

  if (!emailRegex.test(email)) {
    return 'Please enter a valid email address.';
  }

  if (!phoneDigitsRegex.test(phoneno)) {
    return 'Phone number must be exactly 10 digits.';
  }

  return null;
};


  const openModal = (title, message, status = 'info') => {
    setModalContent({ title, message, status });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormMessage('');
    const error = validateForm();
    if (error) {
      setFormMessage(error);
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = { ...formData };
      const response = await fetch(`${API_BASE}/forms/services`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const text = await response.text().catch(() => '');
        throw new Error(`HTTP ${response.status} ${text || ''}`.trim());
      }

      const result = await response.json().catch(() => ({}));
      const success = result && (result.success === true || (result.message && /success/i.test(result.message)));

     if (success) {

  openModal(
    'Success',
    'Your quote request was sent successfully. We will contact you shortly.',
    'success'
  );

  setFormData({
    name: '',
    email: '',
    phoneno: '',
    country_code: '+91',
    location: '',
    industry_type: '',
    availability: '',
    type_of_service: '',
  });

  // Keep popup open for 5 seconds
  setTimeout(() => {
    closeModal();
  }, 5000);

} else {
  const msg = result?.message || 'Failed to send request. Please try again later.';
  setFormMessage(msg);
}

    } catch (err) {
      const message = err?.message || 'Something went wrong. Please try again.';
      setFormMessage(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Scroll-to-top state
  const [showScroll, setShowScroll] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  useEffect(() => {
    let ticking = false;
    const circumference = 307.919;

    const updateProgress = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const docHeight = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
      const progress = (scrollTop / docHeight) * circumference;
      setScrollProgress(progress);
      setShowScroll(scrollTop > 120);
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateProgress);
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    updateProgress();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleLinkClick = (path, pageName) => console.log(`Navigated to ${pageName} at ${path}`);

  const cardStyle = { background: '#ECF0FE', color: '#210A4A' };
  const iconContainerStyle = { background: 'white' };

  return (
    <div className="min-h-screen bg-white font-sans text-base leading-relaxed">
      <Helmet>
        <title>Business Process Outsourcing (BPO) Services – Hyderabad</title>
        <meta
          name="description"
          content="SecurXpert offers reliable Business Process Outsourcing (BPO) services in Hyderabad. Boost efficiency, reduce costs and improve customer satisfaction today."
        />
      </Helmet>

      <Navbar />

      {/* HERO */}
      <header className="relative w-full">
        <div
          className="relative w-full h-[317px] bg-center bg-cover bg-no-repeat"
          style={{ backgroundImage: "url('../img/bpobanner.png')" }}
        >
          {/* Dark overlay */}
          <div className="absolute inset-0 bg-black/70 lg:bg-black/60" />

          {/* Centered text content */}
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 z-10">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 drop-shadow-md">
              Business Process Outsourcing Services
            </h1>

            <div className="flex flex-col items-center gap-3">
              <div className="flex items-center gap-2 text-sm sm:text-base">
                <Link to="/" className="hover:underline">Home</Link>
                <svg
                  width="7"
                  height="10"
                  viewBox="0 0 7 10"
                  fill="none"
                  className="mt-[2px]"
                >
                  <path
                    d="M0.297 0.262C0.105 0.426 -0.002 0.648 0 0.878C0.002 1.109 0.113 1.329 0.308 1.492L4.02 4.604L0.366 7.711C0.173 7.875 0.067 8.097 0.069 8.328C0.071 8.558 0.182 8.778 0.377 8.941C0.474 9.022 0.59 9.086 0.717 9.13C0.844 9.174 0.981 9.196 1.118 9.195C1.255 9.194 1.391 9.171 1.518 9.126C1.644 9.081 1.758 9.016 1.854 8.933L6.232 5.212C6.329 5.131 6.405 5.034 6.457 4.927C6.509 4.821 6.535 4.706 6.534 4.591C6.533 4.476 6.505 4.362 6.451 4.256C6.397 4.15 6.319 4.054 6.221 3.974L1.774 0.254C1.677 0.173 1.561 0.109 1.434 0.065C1.307 0.021 1.171 -0.001 1.033 0C0.896 0.001 0.76 0.024 0.634 0.069C0.507 0.114 0.393 0.18 0.297 0.262Z"
                    fill="white"
                  />
                </svg>
                <span>Business Process Outsourcing (BPO) Services</span>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* INTRO */}
      <section className="py-10 sm:py-14 md:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div className="relative w-full">
              <img
                src="img/customer.png"
                alt="Business Process Outsourcing"
                className="w-full h-56 sm:h-64 md:h-80 lg:h-96 object-cover rounded-xl shadow-xl"
                loading="lazy"
              />
              {/* <img
                src="img/customer.png"
                alt="Automation & BPO"
                className="hidden sm:block absolute bottom-3 right-3 w-24 sm:w-32 md:w-40 lg:w-44 h-16 sm:h-24 md:h-32 object-cover rounded-xl shadow-2xl border-6 border-white transform translate-x-2 translate-y-2"
                loading="lazy"
              /> */}
            </div>
            <div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-4 text-[#210A4A]">
                Business Process Outsourcing Services in Hyderabad
              </h2>
              <p className="text-gray-700 text-base sm:text-lg leading-relaxed mb-4">
                Our Business Process Outsourcing services handle tasks such as data entry, payroll, finance,
                and HR so your team can focus on growing your business. We manage them efficiently,
                securely and reliably.
              </p>
              <p className="text-gray-700 text-base sm:text-lg leading-relaxed mb-6">
                With AI, automation and secure workflows, SecurXpert helps you streamline operations,
                reduce costs and improve customer satisfaction across every touchpoint.
              </p>
              <Link
                to="/get-quoted"
                onClick={() => handleLinkClick('/get-quoted', 'Talk to BPO Experts')}
                className="inline-block px-6 py-3 rounded-full font-semibold text-white bg-[#3E66F3] hover:bg-[#355fd3] transition"
              >
                Talk to Our BPO Experts
              </Link>
            </div>
          </div>

          {/* SERVICES GRID */}
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              {
                title: 'Business Process Outsourcing',
                icon: <FaBuilding className="text-3xl" />,
                description:
                  'End-to-end BPO covering data entry, payroll, finance and HR so your teams can stay focused on growth.',
              },
              {
                title: 'Robotic Process Automation',
                icon: <FaCogs className="text-3xl" />,
                description:
                  'Automate invoice processing, claims processing and system updates for faster, more accurate operations.',
              },
              {
                title: 'Intelligent Document Processing',
                icon: <FaGlobe className="text-3xl" />,
                description:
                  'Use AI and OCR to extract, analyse and process document data with high accuracy and compliance.',
              },
              {
                title: 'Omnichannel Customer Support',
                icon: <FaHeadset className="text-3xl" />,
                description:
                  '24/7 customer assistance via chatbots and live agents to deliver fast, reliable, cost-effective support.',
              },
              {
                title: 'Business Process Automation',
                icon: <FaCloud className="text-3xl" />,
                description:
                  'Automate workflows like onboarding, procurement and logistics with smart, connected systems.',
              },
              {
                title: 'Conversational AI & Virtual Agents',
                icon: <FaLink className="text-3xl" />,
                description:
                  'AI-powered virtual agents that handle queries and orders round-the-clock with human-like interactions.',
              },
            ].map((service, i) => (
              <article
                key={i}
                className="rounded-xl shadow-lg p-6 flex flex-col items-center text-center hover:shadow-2xl transform transition hover:scale-[1.02]"
                style={cardStyle}
              >
                <div
                  className="bg-white rounded-full p-3 w-16 h-16 flex items-center justify-center mb-4"
                  style={iconContainerStyle}
                >
                  {service.icon}
                </div>
                <h3 className="text-lg font-bold mb-2" style={{ color: cardStyle.color }}>
                  {service.title}
                </h3>
                <p className="text-sm leading-relaxed text-gray-700">{service.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* DEVELOPMENT APPROACH / BPO APPROACH */}
      <section className="py-10 md:py-14 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-center mb-8 text-[#210A4A]">
            A Smarter Approach to BPO Services
          </h2>
          <div className="space-y-8">
            {[
              {
                number: '1',
                title: 'Business Process Assessment',
                desc: 'We deep-dive into your current workflows to identify inefficiencies and automation opportunities. Every engagement starts with a clear understanding of your process landscape.',
                icon: <FaLightbulb className="text-3xl" />,
                align: 'left',
              },
              {
                number: '2',
                title: 'AI & Automation Integration',
                desc: 'We adopt an automation-first mindset—integrating AI models, RPA bots and smart tools that work with your existing systems to reduce manual work.',
                icon: <FaCode className="text-3xl" />,
                align: 'right',
              },
              {
                number: '3',
                title: 'Data-Driven Optimization',
                desc: 'Using analytics and big data frameworks, we provide real-time performance insights for continuous improvements and measurable results.',
                icon: <FaChartLine className="text-3xl" />,
                align: 'left',
              },
              {
                number: '4',
                title: 'Scalable BPO & Ongoing Support',
                desc: 'Scale quickly with 24/7 managed services that grow with your business—whether you are adding new automation layers or expanding support teams.',
                icon: <FaHeadset className="text-3xl" />,
                align: 'right',
              },
            ].map((step, i) => (
              <div
                key={i}
                className={`flex flex-col lg:flex-row ${
                  step.align === 'right' ? 'lg:flex-row-reverse' : ''
                } items-center gap-6 lg:gap-8`}
                data-aos={step.align === 'left' ? 'fade-right' : 'fade-left'}
              >
                <div
                  className="w-full lg:w-64 h-36 lg:h-48 rounded-3xl flex items-center justify-center text-white shadow-xl mb-4 lg:mb-0"
                  style={{
                    background:
                      step.align === 'left'
                        ? 'linear-gradient(180deg, #421492 0%, #14062C 100%)'
                        : 'linear-gradient(180deg, #4E18B0 0%, #210A4A 100%)',
                  }}
                >
                  <div className="text-5xl font-bold opacity-60">{step.number}</div>
                </div>
                <div className="w-full bg-white rounded-2xl shadow-lg p-6 sm:p-8">
                  <div className="flex items-center gap-4 mb-4">
                    <div style={{ color: '#210A4A' }}>{step.icon}</div>
                    <h3 className="text-xl font-bold text-[#210A4A]">{step.title}</h3>
                  </div>
                  <p className="text-gray-700">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TECH STACK / CAPABILITIES */}
      <section className="py-10 bg-[#DBE3FF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-center mb-6 text-[#210A4A]">
            AI-Powered BPO & Automation Capabilities
          </h2>
          <p className="text-center text-gray-700 mb-8 max-w-3xl mx-auto">
            We combine AI, automation and cloud technologies to deliver smarter, leaner and more agile business
            processes across your organisation.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              {
                title: 'Automation & RPA',
                icon: <FaReact className="text-4xl" />,
                tech: 'RPA bots, workflow engines, event-driven automations.',
              },
              {
                title: 'Backend & Integrations',
                icon: <FaNodeJs className="text-4xl" />,
                tech: 'Secure APIs, ERP & CRM integrations, microservices.',
              },
              {
                title: 'Cloud & Scalability',
                icon: <FaAws className="text-4xl" />,
                tech: 'AWS, Azure, GCP for scalable, resilient BPO platforms.',
              },
              {
                title: 'Analytics & Insights',
                icon: <FaChartLine className="text-4xl" />,
                tech: 'BI dashboards, performance analytics, real-time reporting.',
              },
            ].map((item, i) => (
              <div key={i} className="bg-white rounded-xl shadow-lg p-6 flex flex-col items-center text-center">
                <div className="mb-4">{item.icon}</div>
                <h4 className="text-lg font-bold mb-2 text-[#210A4A]">{item.title}</h4>
                <p className="text-sm text-gray-700">{item.tech}</p>
              </div>
            ))}
          </div>
          <div className="text-center mt-8">
            <a
  href="https://www.adp.com/resources/articles-and-insights/articles/w/what-is-bpo.aspx"
  target="_blank"
  rel="noopener noreferrer"
  onClick={() => handleLinkClick('/services', 'Learn More')}
  className="inline-block px-6 py-3 rounded-full font-semibold text-white bg-[#210A4A]"
>
  Learn More
</a>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section className="py-10 text-white bg-[#210A4A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-center mb-8">
            Why Businesses Trust SecurXpert for BPO Services?
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {[
              {
                title: 'Customised BPO Strategies',
                icon: <FaTools className="text-3xl" />,
                text: 'Solutions built around your unique business processes, challenges and goals.',
              },
              {
                title: 'AI-Powered Automation',
                icon: <FaShieldAlt className="text-3xl" />,
                text: 'Eliminate repetitive work with intelligent automation that unlocks smarter workflows.',
              },
              {
                title: 'Cost-Effective & Scalable',
                icon: <FaClock className="text-3xl" />,
                text: 'Maximise ROI with flexible BPO models that scale as your business grows.',
              },
              {
                title: 'End-to-End Management',
                icon: <FaExpand className="text-3xl" />,
                text: 'From consultation to implementation and ongoing support, we are with you every step.',
              },
            ].map((item, i) => (
              <div key={i} className="bg-white rounded-xl p-4 flex items-start gap-4 shadow-md">
                <div className="text-[#210A4A]">{item.icon}</div>
                <div>
                  <h3 className="text-lg font-bold text-[#210A4A]">{item.title}</h3>
                  <p className="text-gray-700 text-sm">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-10 text-center bg-[#DBE3FF]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-4 text-[#210A4A]">
            Let&apos;s Build Smarter, Leaner, and More Agile Businesses Together
          </h2>
          <p className="text-gray-700 mb-6">
            Ready to streamline operations, boost accuracy and scale faster with our AI-powered BPO services?
            Join the growing list of companies transforming their business processes with SecurXpert.
          </p>
          <p className="text-gray-700 mb-6">
            Let us talk today, because the future of business is intelligent, automated and effortless.
          </p>
          <Link
            to="/contact-us"
            className="inline-block px-8 py-3 rounded-full font-semibold text-white bg-[#210A4A]"
          >
            Get Started Today
          </Link>
        </div>
      </section>

      {/* FAQs */}
      <section className="py-10 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-center mb-8 text-[#210A4A]">
            FAQs
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="space-y-4">
              {[
                {
                  q: 'What types of BPO services do you provide?',
                  a: 'We offer efficient BPO services including automation, intelligent document processing and 24/7 customer support to streamline your business operations.',
                },
                {
                  q: 'How does AI enhance your BPO solutions?',
                  a: 'AI speeds up tasks and boosts accuracy by automating repetitive processes, reducing errors and improving overall productivity.',
                },
                {
                  q: 'Is document automation part of your services?',
                  a: 'Yes, we use AI to automate document management efficiently, from data extraction to validation and processing.',
                },
                {
                  q: 'Can your BPO services adapt as our business grows?',
                  a: 'Definitely. Our BPO services are designed to scale easily as your business grows, whether in volume, new processes or new geographies.',
                },
              ].map((faq, i) => (
                <div key={i} className="border rounded-lg shadow-sm overflow-hidden">
                  <button
                    id={`faq-btn-${i}`}
                    type="button"
                    onClick={() => toggleFAQ(i)}
                    aria-expanded={openFAQ === i}
                    aria-controls={`faq-panel-${i}`}
                    className="w-full flex items-center justify-between px-4 sm:px-6 py-3 bg-white text-left focus:outline-none focus:ring-2 focus:ring-[#210A4A]"
                  >
                    <span className="font-semibold">{faq.q}</span>
                    <svg
                      className={`w-5 h-5 transform transition-transform ${
                        openFAQ === i ? 'rotate-180' : 'rotate-0'
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth={2}
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div
                    id={`faq-panel-${i}`}
                    role="region"
                    aria-labelledby={`faq-btn-${i}`}
                    className={`px-4 sm:px-6 overflow-hidden transition-[max-height,opacity] duration-300 ${
                      openFAQ === i ? 'py-4 opacity-100' : 'py-0 opacity-0'
                    }`}
                    style={{ maxHeight: openFAQ === i ? '400px' : '0' }}
                  >
                    <p className="text-gray-700">{faq.a}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg flex flex-col items-center">
              <img
               src="/img/needmorehelp.png"
                alt="FAQs illustration"
                className="w-full sm:w-3/4 h-48 object-cover rounded-lg mb-4"
              />
              <h3 className="text-xl font-bold text-[#210A4A]">Need more help?</h3>
              <p className="text-gray-600 text-center mt-2">
                If your question isn&apos;t listed, contact our team and attach screenshots or documents to help us
                understand your request faster.
              </p>
              <Link
                to="/contact-us"
                onClick={() => handleLinkClick('/contact-us', 'Contact Us from FAQ')}
                className="mt-4 inline-block px-6 py-3 rounded-full bg-[#3E66F3] text-white font-semibold"
              >
                Contact Support
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* QUOTE FORM */}
      <section className="py-10 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div className="space-y-6">
              <h2 className="text-2xl sm:text-3xl font-extrabold text-[#210A4A]">
                Request a <span className="text-[#3E66F3]">BPO Quote</span>
              </h2>
              <p className="text-gray-700">
                Need a free quote for Business Process Outsourcing services? Please feel free to contact us.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex items-center gap-4 bg-white p-4 rounded-lg shadow-md">
                  <div className="p-3 rounded-full bg-[#ECF0FE] text-[#3E66F3]">
                    <FaHeadset className="text-2xl" />
                  </div>
                  <span className="text-gray-700 font-medium">Reply within 24 hours</span>
                </div>
                <div className="flex items-center gap-4 bg-white p-4 rounded-lg shadow-md">
                  <div className="p-3 rounded-full bg-[#ECF0FE] text-[#3E66F3]">
                    <FaHeadset className="text-2xl" />
                  </div>
                  <span className="text-gray-700 font-medium">24/7 Support</span>
                </div>
              </div>
              <div className="mt-6 text-center lg:text-left">
                <div className="inline-flex items-center justify-center text-white p-6 rounded-full w-28 h-28 shadow-lg bg-[#3E66F3]">
                  <FaHeadset className="text-3xl" />
                </div>
                <h5 className="text-gray-700 mt-4">Call us anytime</h5>
                <h3 className="text-gray-800 font-bold">+91 79932 56679</h3>
              </div>
            </div>

            <div className="bg-white border border-gray-100 rounded-xl shadow-xl p-6 sm:p-8">
              <form onSubmit={handleSubmit} noValidate className="space-y-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="sm:col-span-2">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                      Full name
                    </label>
                    <input
                      id="name"
                      type="text"
                      placeholder="e.g., John Doe"
                      value={formData.name}
                      onChange={handleInputChange}
                      className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#3E66F3]"
                      required
                    />
                  </div>

                  <div className="sm:col-span-2">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                      Email address
                    </label>
                    <input
                      id="email"
                      type="email"
                      placeholder="you@example.com"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#3E66F3]"
                      inputMode="email"
                      required
                    />
                  </div>

                  {/* Phone input */}
                  <div className="sm:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Phone number</label>
                    <div className="flex gap-3 flex-col sm:flex-row">
                      <select
                        id="country_code"
                        value={formData.country_code}
                        onChange={handleCountryCodeChange}
                        className="border border-gray-300 rounded-lg px-3 py-3 bg-white w-full sm:w-44"
                        aria-label="Country code"
                      >
                        {countryCodes.map((c, idx) => (
                          <option key={idx} value={c.code}>{`${c.flag} ${c.code} (${c.label})`}</option>
                        ))}
                      </select>

                      <input
                        id="phoneno"
                        type="tel"
                        placeholder="1234567890"
                        value={formData.phoneno}
                        onChange={handleInputChange}
                        className="flex-1 border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#3E66F3] w-full"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        aria-describedby="phone-help"
                        required
                      />
                    </div>
                    <p id="phone-help" className="text-xs text-gray-500 mt-2">
                      Digits only (7–15). Country code selected separately.
                    </p>
                  </div>

                  <div>
                    <label htmlFor="location" className="block text-sm font-medium text-gray-700 mb-1">
                      Location
                    </label>
                    <input
                      id="location"
                      type="text"
                      placeholder="City, State or Country"
                      value={formData.location}
                      onChange={handleInputChange}
                      className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#3E66F3]"
                      required
                    />
                  </div>

                  <div>
                    <label htmlFor="industry_type" className="block text-sm font-medium text-gray-700 mb-1">
                      Industry type
                    </label>
                    <select
                      id="industry_type"
                      value={formData.industry_type}
                      onChange={handleInputChange}
                      className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#3E66F3]"
                      required
                    >
                      <option value="" disabled>
                        Select Industry Type
                      </option>
                      <option>Finance</option>
                      <option>Healthcare</option>
                      <option>Retail</option>
                      <option>Education</option>
                      <option>Manufacturing</option>
                      <option>Other</option>
                    </select>
                  </div>

                  <div>
                    <label htmlFor="availability" className="block text-sm font-medium text-gray-700 mb-1">
                      Availability
                    </label>
                    <select
                      id="availability"
                      value={formData.availability}
                      onChange={handleInputChange}
                      className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#3E66F3]"
                      required
                    >
                      <option value="" disabled>
                        Availability
                      </option>
                      <option>Immediate</option>
                      <option>1-2 weeks</option>
                      <option>1 month+</option>
                    </select>
                  </div>

                  <div className="sm:col-span-2">
                    <label htmlFor="type_of_service" className="block text-sm font-medium text-gray-700 mb-1">
                      Type of service
                    </label>
                    <select
                      id="type_of_service"
                      value={formData.type_of_service}
                      onChange={handleInputChange}
                      className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#3E66F3]"
                      required
                    >
                      <option value="" disabled>
                        Select Type of Service
                      </option>
                      <option>BPO & Process Outsourcing</option>
                      <option>Automation & RPA</option>
                      <option>Customer Support Services</option>
                      <option>Document & Data Processing</option>
                      <option>Other</option>
                    </select>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full text-white font-semibold py-3 rounded-lg text-lg bg-[#210A4A] disabled:opacity-60"
                  >
                    {isSubmitting ? 'Sending...' : 'Send Message'}
                  </button>
                </div>

                {formMessage && (
                  <div
                    className={`text-center font-medium ${
                      formMessage.toLowerCase().includes('success') ? 'text-green-600' : 'text-red-600'
                    }`}
                  >
                    {formMessage}
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {/* Back to Top */}
      {showScroll && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full shadow-lg bg-gradient-to-r from-blue-500 to-blue-700"
          aria-label="Scroll to top"
        >
          <svg
            className="progress-circle -rotate-90 w-12 h-12 absolute"
            viewBox="-1 -1 102 102"
            aria-hidden
          >
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              fill="none"
              stroke="white"
              strokeWidth="4"
              strokeDasharray="307.919"
              strokeDashoffset={307.919 - scrollProgress}
              style={{ transition: 'stroke-dashoffset 0.15s linear' }}
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6 text-white relative z-10"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
            aria-hidden
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
          </svg>
        </button>
      )}

      {/* Modal */}
      {showModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center px-4 py-6"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-title"
        >
          <div className="absolute inset-0 bg-black opacity-40" onClick={closeModal} />
          <div className="relative bg-white rounded-lg shadow-xl max-w-lg w-full p-6 z-10">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                {modalContent.status === 'success' ? (
                  <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center text-green-700">
                    ✓
                  </div>
                ) : modalContent.status === 'error' ? (
                  <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center text-red-700">
                    !
                  </div>
                ) : (
                  <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-700">
                    i
                  </div>
                )}
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold" id="modal-title">
                  {modalContent.title}
                </h3>
                <p className="mt-2 text-sm text-gray-700">{modalContent.message}</p>
              </div>
              <button
                onClick={closeModal}
                aria-label="Close dialog"
                className="ml-4 text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BusinessProcessOutsourcing;
